import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Pencil, Trash2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import { IColumn, IHead, IUser } from "Interfaces/interface.datatable";

const headDiv: IHead[] = [
  {
    id: 1,
    heading: "Product Catalog Dashboard",
    text: "Manage and track all your generated product catalogs in one place.",
    btnName: "Create New Catalog",
  },
  {
    id: 2,
    heading: "Mockup Generator Dashboard",
    text: "View your previously generated mockups or create fresh new ones for your products.",
    btnName: "Generate New Mockup",
  },
  {
    id: 3,
    heading: "Enquiry Dashboard",
    text: "Access, track, and create inquiries efficiently.",
    btnName: "Add New Enquiry",
  },
];

const columnTitle: IColumn[] = [
  {
    columnName: "Image",
  },
  {
    columnName: "Name",
  },
  {
    columnName: "Date Created",
  },
];

const data: IUser[] = [
  {
    id: "1",
    name: "Lindsay Walton",
    image: "https://placehold.co/50x50/f0f0f0/000000?text=LW",
    date: "11/04/2005",
  },
  {
    id: "2",
    name: "Courtney Henry",
    image: "https://placehold.co/50x50/e0e0e0/000000?text=CH",
    date: "11/04/2005",
  },
  {
    id: "3",
    name: "Tom Cook",
    image: "https://placehold.co/50x50/d0d0d0/000000?text=TC",
    date: "11/04/2005",
  },
  {
    id: "4",
    name: "Whitney Francis",
    image: "https://placehold.co/50x50/c0c0c0/000000?text=WF",
    date: "11/04/2005",
  },
  {
    id: "5",
    name: "Leonard Krasner",
    image: "https://placehold.co/50x50/b0b0b0/000000?text=LK",
    date: "11/04/2005",
  },
  {
    id: "6",
    name: "Floyd Miles",
    image: "https://placehold.co/50x50/a0a0a0/000000?text=FM",
    date: "11/04/2005",
  },
  {
    id: "7",
    name: "Jane Doe",
    image: "https://placehold.co/50x50/909090/000000?text=JD",
    date: "12/05/2006",
  },
  {
    id: "8",
    name: "John Smith",
    image: "https://placehold.co/50x50/808080/000000?text=JS",
    date: "01/06/2007",
  },
  {
    id: "9",
    name: "Emily White",
    image: "https://placehold.co/50x50/707070/000000?text=EW",
    date: "02/07/2008",
  },
  {
    id: "10",
    name: "Michael Brown",
    image: "https://placehold.co/50x50/606060/000000?text=MB",
    date: "03/08/2009",
  },
  {
    id: "11",
    name: "Sarah Green",
    image: "https://placehold.co/50x50/505050/000000?text=SG",
    date: "04/09/2010",
  },
  {
    id: "12",
    name: "David Lee",
    image: "https://placehold.co/50x50/404040/000000?text=DL",
    date: "05/10/2011",
  },
  {
    id: "13",
    name: "Olivia Clark",
    image: "https://placehold.co/50x50/303030/000000?text=OC",
    date: "06/11/2012",
  },
  {
    id: "14",
    name: "Daniel Taylor",
    image: "https://placehold.co/50x50/202020/000000?text=DT",
    date: "07/12/2013",
  },
  {
    id: "15",
    name: "Sophia Miller",
    image: "https://placehold.co/50x50/101010/000000?text=SM",
    date: "08/01/2014",
  },
  {
    id: "16",
    name: "James Wilson",
    image: "https://placehold.co/50x50/000000/ffffff?text=JW",
    date: "09/02/2015",
  },
  {
    id: "17",
    name: "Ava Moore",
    image: "https://placehold.co/50x50/cccccc/000000?text=AM",
    date: "10/03/2016",
  },
  {
    id: "18",
    name: "Ethan Hall",
    image: "https://placehold.co/50x50/bbbbbb/000000?text=EH",
    date: "11/04/2017",
  },
  {
    id: "19",
    name: "Mia King",
    image: "https://placehold.co/50x50/aaaaaa/000000?text=MK",
    date: "12/05/2018",
  },
  {
    id: "20",
    name: "Alexander Wright",
    image: "https://placehold.co/50x50/999999/000000?text=AW",
    date: "01/06/2019",
  },
  {
    id: "21",
    name: "Charlotte Lee",
    image: "https://placehold.co/50x50/888888/000000?text=CL",
    date: "02/07/2020",
  },
  {
    id: "22",
    name: "Benjamin Green",
    image: "https://placehold.co/50x50/777777/000000?text=BG",
    date: "03/08/2021",
  },
  {
    id: "1",
    name: "Lindsay Walton",
    image: "https://placehold.co/50x50/f0f0f0/000000?text=LW",
    date: "11/04/2005",
  },
  {
    id: "2",
    name: "Courtney Henry",
    image: "https://placehold.co/50x50/e0e0e0/000000?text=CH",
    date: "11/04/2005",
  },
  {
    id: "3",
    name: "Tom Cook",
    image: "https://placehold.co/50x50/d0d0d0/000000?text=TC",
    date: "11/04/2005",
  },
  {
    id: "4",
    name: "Whitney Francis",
    image: "https://placehold.co/50x50/c0c0c0/000000?text=WF",
    date: "11/04/2005",
  },
  {
    id: "5",
    name: "Leonard Krasner",
    image: "https://placehold.co/50x50/b0b0b0/000000?text=LK",
    date: "11/04/2005",
  },
  {
    id: "6",
    name: "Floyd Miles",
    image: "https://placehold.co/50x50/a0a0a0/000000?text=FM",
    date: "11/04/2005",
  },
  {
    id: "7",
    name: "Jane Doe",
    image: "https://placehold.co/50x50/909090/000000?text=JD",
    date: "12/05/2006",
  },
  {
    id: "8",
    name: "John Smith",
    image: "https://placehold.co/50x50/808080/000000?text=JS",
    date: "01/06/2007",
  },
  {
    id: "9",
    name: "Emily White",
    image: "https://placehold.co/50x50/707070/000000?text=EW",
    date: "02/07/2008",
  },
  {
    id: "10",
    name: "Michael Brown",
    image: "https://placehold.co/50x50/606060/000000?text=MB",
    date: "03/08/2009",
  },
  {
    id: "11",
    name: "Sarah Green",
    image: "https://placehold.co/50x50/505050/000000?text=SG",
    date: "04/09/2010",
  },
  {
    id: "12",
    name: "David Lee",
    image: "https://placehold.co/50x50/404040/000000?text=DL",
    date: "05/10/2011",
  },
  {
    id: "13",
    name: "Olivia Clark",
    image: "https://placehold.co/50x50/303030/000000?text=OC",
    date: "06/11/2012",
  },
  {
    id: "14",
    name: "Daniel Taylor",
    image: "https://placehold.co/50x50/202020/000000?text=DT",
    date: "07/12/2013",
  },
  {
    id: "15",
    name: "Sophia Miller",
    image: "https://placehold.co/50x50/101010/000000?text=SM",
    date: "08/01/2014",
  },
  {
    id: "16",
    name: "James Wilson",
    image: "https://placehold.co/50x50/000000/ffffff?text=JW",
    date: "09/02/2015",
  },
  {
    id: "17",
    name: "Ava Moore",
    image: "https://placehold.co/50x50/cccccc/000000?text=AM",
    date: "10/03/2016",
  },
  {
    id: "18",
    name: "Ethan Hall",
    image: "https://placehold.co/50x50/bbbbbb/000000?text=EH",
    date: "11/04/2017",
  },
  {
    id: "19",
    name: "Mia King",
    image: "https://placehold.co/50x50/aaaaaa/000000?text=MK",
    date: "12/05/2018",
  },
  {
    id: "20",
    name: "Alexander Wright",
    image: "https://placehold.co/50x50/999999/000000?text=AW",
    date: "01/06/2019",
  },
  {
    id: "21",
    name: "Charlotte Lee",
    image: "https://placehold.co/50x50/888888/000000?text=CL",
    date: "02/07/2020",
  },
  {
    id: "22",
    name: "Benjamin Green",
    image: "https://placehold.co/50x50/777777/000000?text=BG",
    date: "03/08/2021",
  },
];

const rowVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      ease: "easeOut" as const,
      duration: 0.3,
    },
  }),
  hover: {
    transition: { duration: 0.2 },
  },
};

const DataTable: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page

  const location = useLocation();

  const [currentDisplayedPath, setCurrentDisplayedPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentDisplayedPath(location.pathname);
  }, [location.pathname]);

  // Based on the current path, select the appropriate header information
  const currentHeaderData = headDiv.find(
    (head) =>
      (location.pathname === "/catalog-dashboard" && head.id === 1) ||
      (location.pathname === "/mockup-dashboard" && head.id === 2) ||
      (location.pathname === "/enquiry-dashboard" && head.id === 3)
  ) || headDiv[0];

  // Calculate the indices for slicing the data array
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const getVisiblePageNumbers = () => {
    const pageNumbers = new Set<number>();

    pageNumbers.add(1);
    pageNumbers.add(totalPages);

    pageNumbers.add(currentPage);
    if (currentPage > 1) pageNumbers.add(currentPage - 1);
    if (currentPage < totalPages) pageNumbers.add(currentPage + 1);

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.add(i);
      }
    } else {
      if (currentPage - 2 > 1 && currentPage - 2 > 0)
        pageNumbers.add(currentPage - 2);
      if (currentPage + 2 < totalPages) pageNumbers.add(currentPage + 2);
    }

    const sortedPageNumbers = Array.from(pageNumbers).sort((a, b) => a - b);

    const finalPageNumbers: (number | string)[] = [];
    let lastAdded: number | string = 0;

    sortedPageNumbers.forEach((pageNumber) => {
      if (typeof lastAdded === "number" && pageNumber > lastAdded + 1) {
        finalPageNumbers.push("...");
      }
      finalPageNumbers.push(pageNumber);
      lastAdded = pageNumber;
    });

    return finalPageNumbers;
  };

  const visiblePageNumbers = getVisiblePageNumbers();

  return (
    <div className="p-4 sm:p-6 lg:p-8 font-sans flex justify-center items-center">
      <div className="bg-white shadow-lg rounded-xl p-3 w-full max-w-5xl">
        <div
          className="text-center lg:text-start lg:flex justify-between items-end mb-10"
          key={currentHeaderData.id}
        >
          <div className="w-full lg:w-auto">
            <h1 className="text-3xl font-semibold text-gray-900 mb-1">
              {currentHeaderData.heading}
            </h1>
            <p className="text-md text-gray-500">{currentHeaderData.text}</p>
          </div>
          <button className="mt-4 lg:mt-0 px-6 py-3 bg-[#0068ff] text-white font-medium rounded-lg shadow-md focus:outline-none transition duration-150 ease-in-out mx-auto lg:mx-0">
            {currentHeaderData.btnName}
          </button>
        </div>

        {/* User Table Section */}
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-300 table-auto">
            <thead className="bg-blue-500">
              <tr className="">
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-md font-medium text-white uppercase tracking-wider rounded-tl-lg"
                >
                  ID
                </th>
                {columnTitle.map((columnName, index) => (
                  <th
                    key={index}
                    scope="col"
                    className="px-6 py-3 text-left text-md font-medium text-white uppercase tracking-wider"
                  >
                    {columnName.columnName}
                  </th>
                ))}
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-md font-medium text-white uppercase tracking-wider rounded-tr-lg"
                ></th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-300">
              {currentData.map((user, index) => (
                <motion.tr
                  key={user.id}
                  className={index % 2 === 0 ? "bg-blue-50" : "bg-blue-100"}
                  variants={rowVariants}
                  initial="hidden"
                  animate="visible"
                  whileHover="hover"
                  custom={index}
                >
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-600">
                    {user.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-600">
                    <img
                      src={user.image}
                      alt={user.name}
                      className="w-14 h-14 object-cover rounded-md"
                    />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-600">
                    {user.name}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-600">
                    {user.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium">
                    {" "}
                    <a
                      href="/"
                      className="text-indigo-600 hover:text-indigo-900 space-x-2 flex justify-center items-center"
                    >
                      <button
                        className="text-blue-600 p-2 hover:bg-blue-200 rounded-full duration-300"
                        title="Edit"
                      >
                        <Pencil size={18} />
                      </button>
                      <button
                        className="text-red-600 p-2 hover:bg-red-200 rounded-full duration-300"
                        title="Delete"
                      >
                        <Trash2 size={18} />
                      </button>
                    </a>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-evenly items-center mt-6">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out"
          >
            <ChevronLeft />
          </button>
          <div className="flex space-x-1">
            {visiblePageNumbers.map((pageNumberOrEllipsis, index) =>
              pageNumberOrEllipsis === "..." ? (
                <span
                  key={`ellipsis-${index}`}
                  className="px-3 py-1 text-gray-700 disabled"
                >
                  . . .
                </span>
              ) : (
                <button
                  key={pageNumberOrEllipsis}
                  onClick={() => paginate(pageNumberOrEllipsis as number)}
                  className={`h-7 w-7 rounded-full font-medium text-sm ${currentPage === pageNumberOrEllipsis
                    ? "bg-indigo-600 text-white"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    } transition duration-150 ease-in-out`}
                >
                  {pageNumberOrEllipsis}
                </button>
              )
            )}
          </div>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed transition duration-150 ease-in-out"
          >
            <ChevronRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataTable;